import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/design_back.png";
import { StaticImage } from "gatsby-plugin-image";

const Designyeppy = () => {
  return (
    <div
      className="design_yeppy p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <h4>UI/UX Design Phase</h4>
            <ul>
              <li>Prototyping</li>
              <p>
                We created low-fidelity prototypes of the super app’s user
                interface, focusing on key features like online grocery
                shopping, delivery, discounts, and payment. We iterated on the
                design based on user feedback and usability testing.
              </p>
              <li>Testing and Feedback</li>
              <p>
                We conducted user testing sessions with Aisha and other
                potential users to gather feedback on the app's functionality
                and design
              </p>
            </ul>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="design_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/design_uiux_img.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={723}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Designyeppy;
